import { SET_SITE_VISITORS } from '../constants';

export const setSiteVisitors = (payload = 0) => ({
  type: SET_SITE_VISITORS,
  payload,
});
